import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"

import SellingIcon from "@images/about/selling.svg"
import BuyingIcon from "@images/about/buying.svg"
import FinanceIcon from "@images/about/finance.svg"
import LogisticIcon from "@images/about/logistic.svg"

import IconWithTextModule from "@modules/IconWithTextModule"

const SaveTimeModule = () => {
  const { t } = useTranslation()

  const params = {
    title: t("AboutMetaloop_Section2"),
    items: [
      {
        text: t("AboutMetaloop_Image_Selling"),
        icon: SellingIcon,
      },
      {
        text: t("AboutMetaloop_Image_Buying"),
        icon: BuyingIcon,
      },
      {
        text: t("AboutMetaloop_Image_Logistics"),
        icon: FinanceIcon,
      },
      {
        text: t("AboutMetaloop_Image_GlobalFinancing"),
        icon: LogisticIcon,
      },
    ],
    className: "p-6 md:pt-0 md:pb-10 md:px-11 xl:p-25 shadow-[0_-1px_0_0_rgba(21,17,36,0.10)] md:shadow-none"
  }
  return <IconWithTextModule {...params} />
}

export default SaveTimeModule
